import React from "react";
import "./SelectThumb.scss";
import {Button} from "../../../../../components/Button";



const SelectThumb = ({
        mainThumb = 0,
        imgSrc = [],
        updateMedia = ()=>{},
        nextSteep = ()=>{}
    }) => {

    return (
        <div id="tag-moderations-qualification-medias-select-thumb">
            <div className={"category-title"}>Quelle image est la plus représentative ?</div>
            <div className={"group-thumb"}>
                {imgSrc.map((src, index) =>{
                    index = index + 1;
                    return <img key={index} className={mainThumb === index ? "active" : ""} onClick={()=>updateMedia(index)} alt={`img ${index}`} src={`${src}?width=222&height=222`} />
                })}
            </div>
            <div className={"w-100 flex-jc-c"}>
                {mainThumb > 0 ? <Button content={"Confirmer la thumb"} className={"btn-next"} onClick={() => nextSteep()}/> : <span className={"text-danger"}>Veuillez sélectionner une image principale </span>}
            </div>
        </div>
    )
}

export default SelectThumb;